import React from "react";
import CreateCardForm from "./components/CreateCardForm";

export default function AdminPage() {
  return (
    <div className="p-6">
      <h1 className="text-xl font-bold mb-4">Gestion des cartes</h1>
      <CreateCardForm />
    </div>
  );
}
